<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "Vehicles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('vehicles.plural')) }},
    resourceRoute: {default: 'vehicles'},
    modelVariable: {default: 'vehicle'},
    denyCreate: { type: Boolean, default() { return !this.$auth.hasPermissionTo("vehicles.create") } }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('vehicles.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('vehicles.plural')),
          href: "/vehicles",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'id',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        name: { type: String, label: this.lodash.startCase(this.$t('vehicles.name')) },
        license_plate: { type: String, label: this.lodash.startCase(this.$t('vehicles.license_plate')) },
      }
    }
  },
  computed: {
    columns() {
      return {
        ['vehicle']: [
          { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
          {
            key: 'type',
            label: this.lodash.startCase(this.$t('vehicles.name')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              computed: {
                customLabel() {
                  let label = this.item.name

                  if (this.item.type === 'heavy') label = this.$t('vehicles.truck')
                  else if (this.item.type === 'medium') label = this.$t('vehicles.crank_truck')
                  else if (this.item.type === 'light') label = this.$t('vehicles.pickup')

                  return label
                }
              },
              template: '<div style="width: 200px" class="text-truncate" :title="item.name">{{ lodash.upperFirst(customLabel) }}</div>'
            }
          },
          {
            key: 'license_plate',
            label: this.lodash.startCase(this.$t('vehicles.license_plate')),
            thStyle: { minWidth: '100px' },
            sortable: false,
            component: {
              props: ['item'],
              template: '<span style="white-space: pre">{{ item.license_plate }}</span>'
            }
          },
          {
            key: 'description',
            label: this.lodash.startCase(this.$t('vehicles.description')),
            thStyle: { minWidth: '400px' },
            sortable: false,
            component: {
              props: ['item'],
              template: '<div v-html="item.description"></div>'
            }
          },
          { key: 'action', label: this.$t('Action'), class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      return this.$axios.delete(`/vehicles/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/vehicles', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          ...this.modelPolicy(),
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    },
    modelPolicy() {
      let modelPolicy = {
        _denyShow: false,
        _denyEdit:  false,
        _denyDelete: true,
      }
      let userPolicy = {
        _denyEdit:  !this.$auth.hasPermissionTo('vehicles.edit'),
        _denyDelete: !this.$auth.hasPermissionTo('vehicles.delete'),
      }
      return {
        ...modelPolicy,
        ...userPolicy,
      }
    },
  },
};
</script>
